/* eslint-disable react/prop-types, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'
// eslint-disable-next-line
import FolderTree from './FolderTree'
import { selectBoards } from '../selectors'
import useDragAndDropList from '../hooks/useDragAndDropList'
import { randomContentId } from '../helpers'
import { withFirebase } from '../Firebase'

const AddBoard = (props) => (
  <div className="boardListAddBoard" onClick={props.onClick}>
    <div className="boardListAddBoardFrame">
      <div className="boardListAddBoardText">New Board</div>
    </div>
  </div>
)

const BoardList = ({
  boards,
  order,
  createContent,
  setBoardsOrder,
  firebase,
}) => {
  const [
    list,
    draggedTo,
    onDragStart,
    onDragOver,
    onDrop,
    onDragLeave,
    setDefaultList,
  ] = useDragAndDropList(setBoardsOrder)

  useEffect(() => {
    setDefaultList(order)
  }, [order, setDefaultList])

  const createBoard = () => {
    const userId = firebase.auth.currentUser.uid.toString()
    const contentId = randomContentId()

    createContent(contentId, userId)
  }

  const showPlaceHolder = (index) => draggedTo === Number(index)

  return (
    <div className="boardList">
      {boards &&
        list.map((contentId, index) =>
          showPlaceHolder(index) ? (
            <div
              className="boardListBoardPlaceHolder"
              draggable
              key={contentId}
              data-position={index}
              onDragStart={onDragStart}
              onDragOver={onDragOver}
              onDrop={onDrop}
              onDragLeave={onDragLeave}
            >
              &nbsp;
            </div>
          ) : (
            <div
              className="boardListBoard"
              draggable
              key={contentId}
              data-position={index}
              onDragStart={onDragStart}
              onDragOver={onDragOver}
              onDrop={onDrop}
              onDragLeave={onDragLeave}
            >
              <FolderTree contentId={contentId} content={boards[contentId]} />
            </div>
          ),
        )}
      <AddBoard onClick={createBoard} />
    </div>
  )
}

function mapStateToProps(state) {
  return selectBoards(state)
}

const ConnectedBoardList = connect(
  mapStateToProps,
  actions,
)(withFirebase(BoardList))
export default ConnectedBoardList
